<template>
  <div id="product" class="wow" :class="aniRandomVal" data-wow-duration="1s">
    <img class="product-pic" :src="product.pic" />
    <span class="product-name">{{ product.name }}</span>
    <span class="price">
      ￥{{
      product.promotionPrice ? product.promotionPrice : product.price
      }}
    </span>
    <span class="orign-price" v-if="product.promotionPrice">￥{{ product.price }}</span>
    <wx-open-launch-weapp
      v-if="isWxClient()"
      id="launch-btn"
      username="gh_a12b5fd15711"
      :path="wxPath"
      class="wxdetail"
     
    >
    <script type="text/wxtag-template">
        <style>
            .purchdetail{
              width: 100%;
              height: 24px;
              padding:8px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #232328;
              line-height: 24px;
              text-align:center;
              border:1px solid #111;
            }
        </style>
        <span class="purchdetail">去购买</span>
    </script>

    </wx-open-launch-weapp>
    <span v-else class="detail" @click="gotoBuy">去购买</span>
  </div>
</template>
<script>
import { WOW } from "wowjs";
import { sign } from "@/api/index.js";
// import {wx} from "@/assets/js/jweixin-1.6.0.js"
function random(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}
export default {
  name: "Product",
  props: {
    product: {
      type: Object,
      default: {
        pic: "",
        name: "五常有机大米稻花香",
        price: "112",
        promotionPrice: "56",
        detail: ""
      }
    }
  },
  mounted() {
    var wow = new WOW();
    wow.init();
    let va = random(0, this.anis.length);
    this.aniRandomVal = this.anis[va];
    console.log("va=" + va + "value=" + this.aniRandomVal);
  },
  data() {
    return {
      anis: ["bounceIn", "pulse"],
      aniRandomVal: "bounceIn"
    };
  },
  computed: {
    wxPath() {
      return `pages/product/product?id=${this.product.id}`;
    }
  },
  methods: {
    isWxClient() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      }
      return false;
    },
    gotoBuy() {
      window.open(
        this.product.jdUrl ? this.product.jdUrl : this.product.taobaoUrl
      );
    }
  }
};
</script>
<style lang="scss" scoped>
#product {
  &:hover {
    cursor: pointer;
    transform: translateY(-6px);
    -webkit-transform: translateY(-6px);
    -moz-transform: translateY(-6px);
    box-shadow: 0 26px 40px -24px rgba(79, 125, 183, 0.3);
    -webkit-box-shadow: 0 26px 40px -24px rgba(79, 125, 183, 0.3);
    -moz-box-shadow: 0 26px 40px -24px rgba(79, 125, 183, 0.3);
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }
  display: grid;
  grid-template-columns: 50px auto 90px;
  grid-template-rows: 190px repeat(2, 1fr);
  grid-row-gap: 1px;
  grid-auto-flow: column;
  justify-items: center;
  background: rgb(255, 255, 255);
  border: 1px solid #f4f4f4;
  width: 283px;
  height: 336px;
  padding: 8px;
  margin:8px;
  .product-pic {
    width: 160px;
    height: 160px;
    margin-top: 30px;
    grid-column-start: 1;
    grid-column-end: 4;
  }
  .base-label {
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    justify-self: start;
    align-self: flex-start;

    text-align: start;
  }
  .product-name {
    @extend .base-label;
    grid-column-start: 1;
    grid-column-end: 4;
    font-size: 14px;
    text-overflow: ellipsis;
    color: rgba(35, 35, 40, 1);
    line-height: 19.6px;
    align-self: center;
  }
  .price {
    @extend .base-label;
    font-size: 18px;
    font-weight: 500;
    color: rgba(35, 35, 40, 1);
    line-height: 18px;
    margin-top: 8px;
    justify-self: start;
  }

  .orign-price {
    @extend .base-label;
    color: rgba(35, 35, 40, 0.5);
    margin-top: 8px;
    text-decoration: line-through;
  }
  .wxdetail{
    grid-column-start: 3;
    width: 100px;
  }
  .detail {
    @extend .base-label;
    border: 1px solid rgba(35, 35, 40, 1);
    padding: 6px;
    color: rgba(35, 35, 40, 1);
    grid-column-start: 3;
    justify-self: end;
    cursor: pointer;
    &:hover {
      background: #000;
      color: #fff;
      cursor: pointer;
    }
  }
}

@media screen and (max-width: 997px) {
  #product {
    width: 100%;
  }
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Product.vue